var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b',[_vm._v("Email")]),_vm._v(" ou "),_c('b',[_vm._v("senha")]),_vm._v(" inválidos, tente novamente. ")])}]

export { render, staticRenderFns }